<!-- <div class="search_top">
  <div class="search_fields">
    <div class="search_corpora">
      <p-dropdown
        [options]="corporas"
        [(ngModel)]="selected_corpora"
        optionLabel="name"
        [showClear]="false"
        placeholder="Select a Corpora"
      ></p-dropdown>

      <p-iconField iconPosition="left" class="input_search_text">
        <p-inputIcon styleClass="pi pi-search" />
        <input
          (keydown.enter)="search_term_for_videos()"
          type="text"
          autofocus
          (onInput)="is_search_clicked.emit(false)"
          pInputText
          placeholder="Search"
          [(ngModel)]="searchService.search_term"
        />
      </p-iconField>
    </div>

    <p-menu
      #searchfieldsMenu
      [model]="search_fields_menu"
      [popup]="true"
    ></p-menu>

    @if (commonservice.get_length(commonservice.video_data)>0 || searchService.dropdowns?.length > 0) {
    @for (item of searchService.dropdowns; track $index) {
    <p-floatLabel [innerHTML]="item"> </p-floatLabel>
    }
    <i
      *ngIf="searchService.dropdowns?.length > 0"
      class="pi pi-trash text-xl cursor-pointer"
      (click)="remove()"
    ></i>
    }
  </div>

  <div class="cta-buttons">
    <p-button
    class="mouse-pointer"
    (mouseover)="searchfieldsMenu.toggle($event)"
    (click)="searchfieldsMenu.toggle($event)"
    icon="pi pi-plus"
    *ngIf="searchService.show_filter_button || this.searchService.dropdowns.length != 0"
  ></p-button>
    <p-button label="Clear All" [outlined]="true" *ngIf="searchService.show_filter_button" (onClick)="searchService.reset()"></p-button>
    <p-button
      label="Search"
      icon="pi pi-search"
      [disabled]="searchService.all_search_terms.text_query === ''"
      (onClick)="search_term_for_videos()"
    ></p-button>
  </div>
</div> -->

<div class="search">
  <div class="search_div">
    <p-iconField iconPosition="left" class="input_search_text">
      <p-inputIcon styleClass="pi pi-search" />
      <input
        (keydown.enter)="search_term_for_videos()"
        type="text"
        styleClass="search_bar"
        autofocus
        (onInput)="is_search_clicked.emit(false)"
        pInputText
        placeholder="Search"
        [(ngModel)]="searchService.search_term"
      />
    </p-iconField>
    @if ( commonservice.get_length(commonservice.video_data) > 0 ) {
    <div class="cta-buttons">
      <!--<p-button
        label="Reset"
        [outlined]="true"
        *ngIf="searchService.search_term != ''"
        (onClick)="searchService.reset()"
      ></p-button>-->
      <p-button
        class="button-font"
        label="Search"
        [disabled]="
          searchService.search_term == '' ||
          searchService.search_term.length < 3
        "
        (onClick)="search_term_for_videos()"
      ></p-button>
    </div>
    }
  </div>
  <!-- <div class="cta-buttons">
    <p-button
      label="Clear All"
      [outlined]="true"
      *ngIf="searchService.show_filter_button"
      (onClick)="searchService.reset()"
    ></p-button>
    <p-button
      label="Search"
      icon="pi pi-search"
      [disabled]="searchService.all_search_terms.text_query === ''"
      (onClick)="search_term_for_videos()"
    ></p-button>
  </div> -->
</div>
